<!--Close icon is not in the modal header because header is optional-->
<i class="icon-close outlets-map-modal-close font-xl cursor-pointer"
   (click)="modal.close()">
</i>

@if (config.showHeader && outlets?.length > outletsSubset?.length && outlets.length > 1) {
  <div class="modal-header">
    <div class="font-xl fw-bold uppercase"
         [translate]="'modal.outlets.header'">
      Click on an outlet to see details
    </div>
  </div>
}

<div class="modal-body position-relative">
  @if (!uiContext.isSm()) {
    <ui-map-with-outlets-accordion
      class="outlets-map-modal-wrap"
      [outlets]="config.isShowAll ? outlets : outletsSubset"
      [scheduleOverridesByOutletId]="outletScheduleOverrides.scheduleOverridesByOutletId"
      [shiftMapToRight]="true"
      [isOutletSelectionStateEnabled]="config.isOutletSelectionStateEnabled"
      (onOutletChanged)="outletScheduleOverrides.ensure($event?.bakery?.id, $event?.id)"
    ></ui-map-with-outlets-accordion>
  }

  @if (uiContext.isSm()) {
    <ui-outlets-map-mobile
      class="outlets-map-modal-wrap"
      [outlets]="config.isShowAll ? outlets : outletsSubset"
      [scheduleOverridesByOutletId]="outletScheduleOverrides.scheduleOverridesByOutletId"
      [isOutletSelectionStateEnabled]="config.isOutletSelectionStateEnabled"
      (onOutletChanged)="outletScheduleOverrides.ensure($event?.bakery?.id, $event?.id)"
    ></ui-outlets-map-mobile>
  }
</div>
